// extracted by mini-css-extract-plugin
module.exports = {"summaryVideos":"styles-module--summaryVideos--HocEL","item":"styles-module--item--6E_Qt"};